import React from 'react';
import PropTypes from 'prop-types';
import { RENDERABLE } from '../Utils/propTypes';
import Close from './Close';
import './style.scss';

function Header({ children, hasCloseBtn, onClick }) {
    const shouldRenderClose = hasCloseBtn && typeof onClick === 'function';

    return (
        <header className="modal-summary-header">
            <h2>{children}</h2>
            {shouldRenderClose && <Close onClick={onClick}/>}
        </header>
    );
}

Header.propTypes = {
    children: RENDERABLE.isRequired,
    hasCloseBtn: PropTypes.bool,
    onClick: PropTypes.func
};

Header.defaultProps = {
    hasCloseBtn: true
};

export default Header;
